export class FileInformation {
  constructor(public type : string, public version : number) {}
}
